import React, { useState } from 'react';
import { Modal, Form, Table, Row, Col, Button, Badge } from 'react-bootstrap';
import { Post, DeleteSingle } from '../../../../utils/httpProvider';
import { LICHHOCTHUCHANH_API } from '../../../../utils/apiUrl';
import { toast } from 'react-toastify';

const DepartmentMappingModal = ({ show, onHide, donViData, mappingData, refetchMappings }) => {
    const [newMapping, setNewMapping] = useState({ textTrongExcel: '', donViId: '' });

    const handleSaveMapping = async () => {
        if (!newMapping.textTrongExcel || !newMapping.donViId) {
            toast.warning('Vui lòng nhập tên trong Excel và chọn khoa hệ thống.');
            return;
        }

        try {
            await Post(LICHHOCTHUCHANH_API.CREATE_EXCEL_KHOA_MAPPING, null, {
                textTrongExcel: newMapping.textTrongExcel,
                donViId: newMapping.donViId
            });
            toast.success('Lưu ánh xạ khoa thành công!');
            setNewMapping({ textTrongExcel: '', donViId: '' });
            refetchMappings();
        } catch (err) {
            toast.error(err?.message || 'Không thể lưu cấu hình ánh xạ khoa.');
        }
    };

    const handleDeleteMapping = async (mappingId) => {
        try {
            await DeleteSingle(LICHHOCTHUCHANH_API.DELETE_EXCEL_KHOA_MAPPING, mappingId);
            toast.success('Xóa cấu hình ánh xạ thành công!');
            refetchMappings();
        } catch (err) {
            toast.error(err?.message || 'Không thể xóa cấu hình ánh xạ.');
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered scrollable>
            <Modal.Header closeButton className="border-bottom-0 pb-0">
                <Modal.Title className="font-weight-bold">Quản lý ánh xạ Khoa/Trung tâm (Excel - Hệ thống)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="alert alert-info small shadow-sm mb-4">
                    <i className="fas fa-info-circle mr-2"></i>
                    Cấu hình ánh xạ giúp hệ thống tự động nhận diện chính xác khoa/phòng ban luân chuyển khi đọc file Excel, kể cả khi tên viết tắt hoặc viết không dấu.
                </div>

                <Form className="bg-light p-3 rounded-lg border mb-4">
                    <h6 className="font-weight-bold text-dark mb-3"><i className="fas fa-plus mr-1"></i>Thêm cấu hình ánh xạ mới</h6>
                    <Row className="align-items-end">
                        <Col md={5}>
                            <Form.Group className="mb-0">
                                <Form.Label className="text-muted small font-weight-bold">Tên viết trong Excel</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Ví dụ: Khoa Cấp cứu, K. Cấp cứu..."
                                    value={newMapping.textTrongExcel}
                                    onChange={(e) => setNewMapping({ ...newMapping, textTrongExcel: e.target.value })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={5}>
                            <Form.Group className="mb-0">
                                <Form.Label className="text-muted small font-weight-bold">Khoa tương ứng hệ thống</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={newMapping.donViId}
                                    onChange={(e) => setNewMapping({ ...newMapping, donViId: e.target.value })}
                                    style={{ borderRadius: '8px' }}
                                >
                                    <option value="">-- Chọn khoa hệ thống --</option>
                                    {(donViData || []).map(d => (
                                        <option key={d.id} value={d.id}>
                                            {d.tenDonVi || d.TenDonVi}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </Col>
                        <Col md={2}>
                            <Button variant="primary" className="w-100" onClick={handleSaveMapping} style={{ borderRadius: '8px', padding: '8px' }}>
                                Lưu lại
                            </Button>
                        </Col>
                    </Row>
                </Form>

                <h6 className="font-weight-bold text-dark mb-3"><i className="fas fa-list-ul mr-1"></i>Danh sách ánh xạ đã cấu hình</h6>
                <div className="table-responsive border rounded-lg bg-white">
                    <Table hover className="mb-0" style={{ fontSize: '0.85rem', verticalAlign: 'middle' }}>
                        <thead className="bg-light">
                            <tr>
                                <th className="text-center" style={{ width: '50px' }}>STT</th>
                                <th>Tên trong Excel (Chuẩn hóa)</th>
                                <th>Khoa hệ thống tương ứng</th>
                                <th className="text-center" style={{ width: '90px' }}>Hành động</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(mappingData || []).map((m, idx) => (
                                <tr key={m.id || m.Id}>
                                    <td className="text-center text-muted">{idx + 1}</td>
                                    <td className="font-weight-bold text-dark">{m.textTrongExcel || m.TextTrongExcel}</td>
                                    <td>
                                        <Badge bg="info" className="p-2 text-dark font-weight-bold" style={{ fontSize: '0.8rem' }}>
                                            {m.donVi?.tenDonVi || m.donVi?.TenDonVi || m.donViTen || 'Không rõ'}
                                        </Badge>
                                    </td>
                                    <td className="text-center">
                                        <Button variant="link" size="sm" className="p-1 text-danger text-decoration-none" onClick={() => handleDeleteMapping(m.id || m.Id)}>
                                            <i className="fas fa-trash-alt"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            {(mappingData || []).length === 0 && (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-muted">Chưa cấu hình ánh xạ nào. Các khoa trong Excel sẽ được khớp trực tiếp theo tên.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
            <Modal.Footer className="border-top-0 pt-0">
                <Button variant="outline-secondary" onClick={onHide} style={{ borderRadius: '8px' }}>
                    Đóng lại
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DepartmentMappingModal;
